import type { PublicOrganizationDto } from "../api/models/PublicOrganizationDto";
import type { PublicPartnerDto } from "../api/models/PublicPartnerDto";
import type { PublicProgramDto } from "../api/models/PublicProgramDto";
import type { PublicUserDto } from "../api/models/PublicUserDto";
import type { ResolvedAddressDto } from "../api/models/ResolvedAddressDto";

export class ResourceInfo {
    name?: string;
    image?: string;

    static fromResource(resource: PublicOrganizationDto | PublicProgramDto | PublicPartnerDto | PublicUserDto): ResourceInfo {
        return {
            name: (resource as PublicUserDto).email || resource.name,
            image: (resource as PublicOrganizationDto).image || (resource as PublicProgramDto).logo || (resource as PublicPartnerDto).logo,
        };
    }

    static fromResolvedAddress(resolution: ResolvedAddressDto): ResourceInfo | undefined {
        const resource = resolution.program || resolution.partner || resolution.organization || resolution.user;
        return resource ? this.fromResource(resource) : undefined;
    }
}
